<template>
    <select style="margin-left:20px;" id="select-languages" @change="flipTranslation($event)">
      <option
        :selected="languageQuestionAdmin === 'fr'"
        v-if="$store.state.sondage.languagesAdmin.includes('fr')"
        value="fr"
        aria-role="listitem"
      >
        <div class="media">
          <div class="media-content">
            <h3>{{ $t("language.french") }}</h3>
          </div>
        </div>
      </option>
      <!-- EN -->
      <option
        :selected="languageQuestionAdmin === 'en'"
        v-if="$store.state.sondage.languagesAdmin.includes('en')"
        value="en"
        aria-role="listitem"
      >
        <div class="media">
          <div class="media-content">
            <h3>{{ $t("language.english") }}</h3>
          </div>
        </div>
      </option>
      <option
        :selected="languageQuestionAdmin === 'es'"
        v-if="$store.state.sondage.languagesAdmin.includes('es')"
        value="es"
        aria-role="listitem"
      >
        <div class="media">
          <div class="media-content">
            <h3>{{ $t("language.spanish") }}</h3>
          </div>
        </div>
      </option>
      <option
        :selected="languageQuestionAdmin === 'de'"
        v-if="$store.state.sondage.languagesAdmin.includes('de')"
        value="de"
        aria-role="listitem"
      >
        <div class="media">
          <div class="media-content">
            <h3>{{ $t("language.deutsch") }}</h3>
          </div>
        </div>
      </option>
    </select>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ButtonLanguages',
  computed: {
    ...mapGetters(['selectedCountryLanguage', 'arrayLanguagesUpdated', 'languageQuestionAdmin'])
  },
  data () {
    return {
      selectedCountry: this.$store.getters.sondage_languages[0],
      arrayLanguages: [],
      lang: null
    }
  },
  watch: {
    selectedCountryLanguage (value) {
      this.selectedCountry = value
    },
    arrayLanguagesUpdated () {
      this.arrayLanguages = this.arrayLanguagesUpdated
    }
  },
  created () {
    this.flipTranslation(this.$store.getters.sondage_languages[0])
    this.$store.dispatch(
      'getSondage',
      this.$store.getters.configure_questions_sondage
    )
    if (
      !this.$store.getters.sondage_languages.includes(
        this.$store.state.langage.langue
      )
    ) {
      this.$store.commit(
        'UPDATE_BUTTON_LANGUAGE_QUESTION',
        this.$store.getters.sondage_languages[0]
      )
    }
  },
  methods: {
    flipTranslation (value) {
      if (value.target !== undefined) value = value.target.value
      else value = this.$store.getters.sondage_languages[0]
      this.selectedCountry = value
      this.$store.commit('UPDATE_OPTION_LANGUAGE_SELECT', value)
      this.$store.commit('UPDATE_BUTTON_LANGUAGE_QUESTION', value)
    }
  }
}
</script>
<style scoped>
#select-languages {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #ffffff;
  color:#aaa;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 50%;
  padding-right: 2rem;
  padding-top:0px;
  cursor:pointer;
  border:.8px solid #dddddd
}
select option{
  color: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/question/components/ButtonLanguages.vue